import { bemCN } from "../../config/bem-classname";
import "./rules-page.scss";
import { Menu } from "../../components/menu/menu";

const rulesPageCn = bemCN("rules-page");

export const RulesPage = () => {
  return (
    <div className={rulesPageCn()}>
      <Menu title="Правила использования" />
      <div className={rulesPageCn("text")}>
        <p className={rulesPageCn("title-1")}>1. Общие положения</p>
        <p className={rulesPageCn("simple-text")}>
          1.1. Настоящие правила (далее — «Правила») регулируют использование
          мобильного приложения YUMI (далее — «Приложение»), предназначенного
          для чтения детских сказок с возможностью выбора сюжетных линий.
        </p>
        <p className={rulesPageCn("simple-text")}>
          1.2. Используя Приложение, пользователь (далее — «Пользователь»)
          принимает условия данных Правил.
        </p>
        <p className={rulesPageCn("title-1")}>2. ВОЗРАСТНЫЕ ОГРАНИЧЕНИЯ</p>
        <p className={rulesPageCn("simple-text")}>
          2.1. Приложение предназначено для детей и их родителей, но
          использование должно осуществляться под присмотром взрослых.
        </p>
        <p className={rulesPageCn("simple-text")}>
          2.2. Некоторые элементы интерактивных сказок могут требовать базовых
          навыков чтения или сопровождения взрослого.
        </p>
        <p className={rulesPageCn("title-1")}>
          3. ПРАВА И ОБЯЗАННОСТИ ПОЛЬЗОВАТЕЛЯ
        </p>
        <p className={rulesPageCn("simple-text")}>3.1. Пользователь вправе:</p>
        <ul>
          <li>
            Читать и взаимодействовать с интерактивными сказками в Приложении.
          </li>
          <li>
            Настраивать параметры отображения контента, если такая функция
            доступна.
          </li>
          <li>Сообщать о некорректном контенте через обратную связь.</li>
        </ul>
        <p className={rulesPageCn("simple-text")}>
          3.2. Пользователь обязуется:
        </p>
        <ul>
          <li>
            Не использовать Приложение для целей, нарушающих законодательство.
          </li>
          <li>
            Не предпринимать попыток взлома, модификации или незаконного
            распространения контента.
          </li>
          <li>
            Соблюдать авторские права и не копировать сказки без разрешения
            правообладателя.
          </li>
        </ul>
        <p className={rulesPageCn("title-1")}>4. КОНТЕНТ И АВТОРСКИЕ ПРАВА</p>
        <p className={rulesPageCn("simple-text")}>
          4.1. Все текстовые материалы, иллюстрации, музыкальное сопровождение и
          другие элементы контента являются интеллектуальной собственностью
          разработчиков или партнёров.
        </p>
        <p className={rulesPageCn("simple-text")}>
          4.2. Запрещено копирование, распространение или модификация контента
          без разрешения правообладателя.
        </p>
        <p className={rulesPageCn("title-1")}>
          5. БЕЗОПАСНОСТЬ И КОНФИДЕНЦИАЛЬНОСТЬ
        </p>
        <p className={rulesPageCn("simple-text")}>
          5.1. Приложение не собирает персональные данные детей без согласия
          родителей.
        </p>
        <p className={rulesPageCn("simple-text")}>
          5.2. Пользователь несёт ответственность за безопасность своих данных,
          включая пароль от аккаунта, если он есть.
        </p>
        <p className={rulesPageCn("title-1")}>6. ОПЛАТА И ПОДПИСКА</p>
        <p className={rulesPageCn("simple-text")}>
          6.1. Приложение может содержать платный контент или подписку для
          доступа к дополнительным сказкам.
        </p>
        <p className={rulesPageCn("simple-text")}>
          6.2. Все платежи осуществляются через официальные магазины приложений
          (Google Play, App Store) или через специальные банковские сервисы, а
          возврат средств регулируется их политиками.
        </p>

        <p className={rulesPageCn("title-1")}>7. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
        <p className={rulesPageCn("simple-text")}>
          7.1. Разработчики Приложения не несут ответственности за:
        </p>
        <ul>
          <li>Неправильное использование контента Пользователем.</li>
          <li>
            Технические сбои, вызванные причинами, не зависящими от
            разработчиков.
          </li>
          <li>
            Возможный вред устройству в случае использования Приложения с
            несовместимым оборудованием.
          </li>
        </ul>
        <p className={rulesPageCn("title-1")}>8. ИЗМЕНЕНИЕ ПРАВИЛ</p>
        <p className={rulesPageCn("simple-text")}>
          8.1. Разработчики оставляют за собой право изменять настоящие Правила.
          Обновлённая версия публикуется в Приложении.
        </p>
        <p className={rulesPageCn("simple-text")}>
          8.2. Продолжение использования Приложения после внесения изменений
          означает согласие с новыми условиями.
        </p>
        <p className={rulesPageCn("title-1")}>9. ОБРАТНАЯ СВЯЗЬ</p>
        <p className={rulesPageCn("simple-text")}>
          9.1. По вопросам использования Приложения можно обращаться в службу
          поддержки: yumimyths@gmail.com.
        </p>
        <p className={rulesPageCn("cursice")}>Дата обновления: 03.03.2025</p>
      </div>
    </div>
  );
};
